import styles from "./StatCard.module.css";

/**
 * Big-number card used for Football IQ, concepts learned, games watched.
 * Deliberately one number and one plain-English label, no dashboards.
 */
const StatCard = ({
  label,
  value,
  hint,
  icon,
  tone = "default",
  as: Tag = "div",
  className = "",
  ...rest
}) => (
  <Tag
    className={`${styles.StatCard} ${styles[tone] ?? ""} ${className}`.trim()}
    {...rest}
  >
    {icon && (
      <span className={styles.icon} aria-hidden="true">
        <i className={icon} />
      </span>
    )}
    <span className={`${styles.value} app-numeric`}>{value}</span>
    <span className={styles.label}>{label}</span>
    {hint && <span className={styles.hint}>{hint}</span>}
  </Tag>
);

export default StatCard;
